import { render } from "./BelongsToField.vue?vue&type=template&id=078052f0"
import script from "./BelongsToField.vue?vue&type=script&lang=js"
export * from "./BelongsToField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__